import type { AxisFilterChip, AxisFilterFieldDef } from "@/components/filter";

// Policy 카탈로그의 검색 축. 표에 보이는 열과 1:1 이다. 그래서 필터가 비교하는 문자열은 사용자가
// 읽은 셀 문자열과 같다. 정책 목록 API 는 자유 텍스트 필터를 받지 않고 스코프 카탈로그 전체를
// 반환한다. 그래서 비교는 클라이언트가 한다(rules.md §7, 추가 왕복 없음).
export const POLICY_FILTER_FIELDS = [
  { key: "name", label: "Policy 이름" },
  { key: "experiment", label: "실험" },
  { key: "branch", label: "Branch@Hash" },
  { key: "dataset", label: "Dataset" },
  { key: "owner", label: "소유자" },
] as const satisfies readonly AxisFilterFieldDef<string>[];

export type PolicyFilterField = (typeof POLICY_FILTER_FIELDS)[number]["key"];

export type PolicyFilterChip = AxisFilterChip<PolicyFilterField>;

// 활성 축의 비교 needle 목록. needle 은 **소문자로 정규화**되어 있다. 대소문자를 무시하는 부분
// 일치 검색어이고, 화면에 표시하는 값이 아니다. 칩 표시는 URL 이 보관한 원본 값을 쓴다.
// 적용된 축만 담는다. 그래서 행을 비교할 때 모든 축을 확인하지 않는다.
export type PolicyTextFilters = readonly { key: PolicyFilterField; needle: string }[];

// 칩을 비교 spec 으로 바꾼다. 칩은 축 선언 순서로 정규화되어 오므로 결과 순서도 결정적이다.
export function chipsToPolicyTextFilters(chips: readonly PolicyFilterChip[]): PolicyTextFilters {
  return chips.flatMap((chip) => {
    const needle = chip.value.trim().toLowerCase();
    return needle === "" ? [] : [{ key: chip.key, needle }];
  });
}

// 페이지 캐시 키의 필터 부분.
export function policyTextFilterSignature(filters: PolicyTextFilters): string {
  return filters.map((filter) => `${filter.key}:${filter.needle}`).join("|");
}
